/* 三國逗陣打 · 特效層
 * 特效由動畫事件觸發（見 rig.js 的 events），畫在世界座標，跟著角色面向翻轉。
 * 顏色：事件自帶 col 時用它，否則用武將的特效主色。 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from '../core/sg.ts';

const D = Math.PI / 180, TAU = Math.PI * 2;
const rnd = (a, b) => a + Math.random() * (b - a);
const clamp01 = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);

// 火焰色盤：火、冰、毒、暗、聖
const PAL = {
  fire: ['rgba(255,244,180,0.95)', 'rgba(255,150,50,0.85)', 'rgba(200,40,20,0)', '255,150,50', '#ffb24a'],
  ice: ['rgba(240,252,255,0.95)', 'rgba(140,210,255,0.85)', 'rgba(60,110,220,0)', '140,200,255', '#cfeeff'],
  poison: ['rgba(230,255,190,0.95)', 'rgba(130,210,80,0.85)', 'rgba(40,110,40,0)', '120,220,90', '#b6f07a'],
  shadow: ['rgba(235,210,255,0.9)', 'rgba(150,90,220,0.85)', 'rgba(50,20,90,0)', '150,90,230', '#c9a2ff'],
  holy: ['rgba(255,255,230,0.95)', 'rgba(255,220,120,0.85)', 'rgba(220,160,40,0)', '255,210,110', '#ffe28a'],
};
SG.FXPAL = PAL; // 造型特效（skinfx.ts）可以加自己的色盤
const pal = (k) => PAL[k] || PAL.fire;

function ghostSpec(spec) {
  if (Object.prototype.hasOwnProperty.call(spec, '_ghost')) return spec._ghost; // 形態的 spec 以本體為原型：要自己那份
  const c = {};
  for (const k in spec.c) c[k] = spec.c[k] ? '#b9d3f5' : spec.c[k];
  if (spec.c.cape) c.cape = '#a9c4ea';
  spec._ghost = Object.assign(Object.create(spec), { skin: '#dce9ff', hair: '#9db7df', beardColor: null, eyeColor: null, c });
  return spec._ghost;
}

SG.spawn = function (stage, a, ev, P) {
  if (stage.o.skip && stage.o.skip[ev.fx]) return;
  const s = a.s, f = a.f, spec = a.spec, col = ev.col || spec.fx || '#ffffff';
  const ox = a.x + f * P.px * s, oy = a.y + P.py * s;
  const top = Math.max(stage.o.textTop || 24, a.y - 122 * s);
  const reach = stage.o.reach || 1;
  const fitX = (x, str, size) => { const half = str.length * size * s * 0.52 + 6; return Math.min(stage.W - half, Math.max(half, x)); };
  const E = (o) => stage.fx.push(Object.assign({ x: ox, y: oy, f, s, t: 0, col }, o));
  const P2 = (o) => stage.parts.push(Object.assign({ t: 0 }, o));
  switch (ev.fx) {
    case 'swoosh': E({ type: 'swoosh', life: ev.big ? 0.3 : 0.2, a1: ev.a1, a2: ev.a2, r: ev.big ? 76 : 60 }); break;
    case 'thrust': E({ type: 'thrust', life: 0.18, len: ev.len || 74 }); break;
    case 'ghost': E({ type: 'ghost', x: a.x, y: a.y, life: 0.4, pose: P, spec: ghostSpec(spec) }); break;
    case 'crescent': E({ type: 'crescent', x: ox + f * 30 * s, life: 0.95, speed: 470 }); break;
    case 'fire': E({ type: 'fire', x: ox + f * ev.d * reach * s, life: 1.2, seed: Math.random() * 10, pal: ev.pal }); break;
    case 'glow': E({ type: 'spark', x: ox + f * 4 * s, y: oy - 104 * s, f: 1, life: 0.35, big: 1 }); break;
    case 'aura':
      E({ type: 'aura', ground: true, x: a.x, y: a.y, f: 1, life: 1.5 });
      for (let i = 0; i < 14; i++) P2({ kind: 'chev', x: a.x + rnd(-120, 120) * s * reach, y: a.y + rnd(-20, 10) * s, vx: 0, vy: -rnd(40, 90) * s, g: 0, t: -rnd(0, 0.5), life: 1.1, size: 5 * s, col });
      break;
    case 'seal': E({ type: 'seal', x: a.x + f * 56 * s, y: Math.max((stage.o.textTop || 24) + 44 * s, a.y - 150 * s), f: 1, life: 1.5, ch: ev.ch }); break;
    case 'name': E({ type: 'text', x: fitX(a.x + f * 10 * s, ev.str, 20), y: top, life: 1.3, str: ev.str, size: 20, shake: ev.shake }); break;
    case 'shout': E({ type: 'text', x: fitX(ox + f * 40 * s, ev.str, 26), y: top + 26 * s, life: 1.2, str: ev.str, size: 26, shake: 1 }); break;
    case 'roar': E({ type: 'roar', life: 0.8 }); stage.shake = Math.max(stage.shake, 6); break;
    case 'slam': {
      const x = ox + f * 40 * s;
      E({ type: 'slam', ground: true, x, f: 1, life: 1.2, cracks: cracks(9, 40, 90) });
      for (let i = 0; i < 18; i++) P2({ kind: 'dust', x: x + rnd(-30, 30) * s, y: oy + rnd(-6, 6) * s, vx: rnd(-80, 80) * s, vy: -rnd(10, 50) * s, g: 20 * s, life: rnd(0.6, 1.1), size: rnd(6, 12) * s });
      for (let i = 0; i < 10; i++) P2({ kind: 'rock', x: x + rnd(-20, 20) * s, y: oy - 4 * s, vx: rnd(-120, 120) * s, vy: -rnd(120, 260) * s, g: 700 * s, life: rnd(0.8, 1.2), size: rnd(1.5, 3) * s, floor: oy + rnd(-8, 8) * s, rot: rnd(0, 6) });
      stage.shake = Math.max(stage.shake, 10);
      break;
    }
    case 'bolt': // 投射物：箭、氣彈、風刃、飛刃、火球、冰晶
      E({ type: 'bolt', x: ox + f * 30 * s, y: oy + (ev.dy || 0) * s, life: ev.up ? 0.35 : 0.9, speed: ev.up ? 0 : 560, up: ev.up, shape: ev.shape || 'orb', big: ev.big });
      break;
    case 'rain': {
      const x = ox + f * (ev.d || 170) * reach * s, list = [];
      for (let i = 0; i < 26; i++) list.push({ x: rnd(-70, 70), y: rnd(-14, 14), t0: rnd(0, 0.55) });
      E({ type: 'rain', x, f: 1, life: 1.4, list });
      break;
    }
    case 'whirl': E({ type: 'whirl', ground: true, x: a.x, y: a.y, f: 1, life: 0.9 }); break;
    case 'buff':
      E({ type: 'buff', x: a.x + f * P.px * s, y: a.y, f: 1, life: ev.small ? 0.7 : 1.1, small: ev.small });
      for (let i = 0; i < (ev.small ? 5 : 12); i++) P2({ kind: 'chev', x: a.x + rnd(-24, 24) * s, y: a.y - rnd(0, 40) * s, vx: 0, vy: -rnd(40, 80) * s, g: 0, t: -rnd(0, 0.4), life: 0.9, size: 4 * s, col });
      break;
    case 'heal': {
      const x = a.x + f * 40 * s * reach;
      E({ type: 'heal', ground: true, x, f: 1, life: 1.4 });
      for (let i = 0; i < 16; i++) P2({ kind: 'cross', x: x + rnd(-90, 90) * s * reach, y: a.y + rnd(-16, 16) * s, vx: 0, vy: -rnd(30, 70) * s, g: 0, t: -rnd(0, 0.6), life: 1, size: 4 * s, col });
      break;
    }
    case 'puff':
      for (let i = 0; i < 12; i++) P2({ kind: 'dust', x: ox + rnd(-16, 16) * s, y: oy - rnd(0, 70) * s, vx: rnd(-40, 40) * s, vy: -rnd(0, 30) * s, g: 0, life: rnd(0.4, 0.7), size: rnd(5, 9) * s, tint: '#b8c2d6' });
      break;
    case 'fade': a.alpha = 0.28; stage.after(1.2, () => { a.alpha = 1; }); break;
    case 'chain': E({ type: 'chain', life: 0.9, d: ev.d || 220 }); break;
    case 'thunder': {
      const pts = []; let x = 0;
      for (let y = -300; y <= 0; y += 25) { pts.push([x, y]); x += rnd(-14, 14); }
      pts[pts.length - 1] = [0, 0];
      E({ type: 'thunder', x: ox + f * (ev.d || 170) * reach * s, f: 1, life: 0.75, pts });
      stage.shake = Math.max(stage.shake, 5);
      break;
    }
    case 'shield': E({ type: 'shield', x: a.x, y: a.y, f: 1, life: 1.2 }); break;
    case 'dust':
      for (let i = 0; i < 4; i++) P2({ kind: 'dust', x: ox - f * rnd(0, 20) * s, y: oy - rnd(0, 6) * s, vx: -f * rnd(20, 60) * s, vy: -rnd(10, 30) * s, g: 10 * s, life: rnd(0.4, 0.8), size: rnd(5, 9) * s });
      break;
    case 'impact':
      stage.fx.push({ type: 'spark', x: ox + f * 30 * s, y: oy - 50 * s, f: 1, s, t: 0, life: 0.3, big: 1, col });
      if (ev.pal) E({ type: 'fire', x: ox + f * 50 * s, life: 1.1, seed: Math.random() * 10, pal: ev.pal });
      stage.shake = Math.max(stage.shake, 6);
      break;
    case 'trap': {
      const x = ox + f * (ev.d || 70) * s;
      if (ev.shape === 'fire' || ev.shape === 'poison' || ev.shape === 'ice') {
        [-30, 10, 45].forEach((dx, i) => E({ type: 'fire', x: x + dx * s, y: oy + (i - 1) * 6 * s, life: 1.4, seed: Math.random() * 10, pal: ev.shape, small: 1 }));
      } else {
        const bits = [];
        for (let i = 0; i < 9; i++) bits.push([rnd(-50, 50), rnd(-12, 12), rnd(0, 6)]);
        E({ type: 'trap', ground: true, x, f: 1, life: 1.8, bits, shape: ev.shape });
      }
      break;
    }
    case 'spikes': E({ type: 'spikes', life: 1.1, pal: ev.pal, n: 6 }); stage.shake = Math.max(stage.shake, 4); break;
    case 'summon': {
      const sol = SG.SOLDIERS && SG.SOLDIERS[spec.faction];
      if (!sol) break;
      const pose = SG.poseOf(sol, 'attack', 0.44);
      [[60, -12], [100, 10], [140, -4]].forEach(([dx, dy], i) => stage.fx.push({ type: 'figure', x: a.x + f * dx * s * reach, y: a.y + dy * s, f, s: s * 0.8, t: -i * 0.08, life: 1.3, spec: sol, pose }));
      break;
    }
  }
};

function cracks(n, l0, l1) {
  const out = [];
  for (let i = 0; i < n; i++) {
    const ang = (i / n) * TAU + rnd(-0.2, 0.2), len = rnd(l0, l1), pts = [[0, 0]];
    for (let j = 1; j <= 4; j++) { const r = (len * j) / 4, aj = ang + rnd(-0.25, 0.25); pts.push([Math.cos(aj) * r, Math.sin(aj) * r * 0.3]); }
    out.push(pts);
  }
  return out;
}

// 由遊戲邏輯指定位置的特效（方向技、指定地點技）
SG.fxAt = function (stage, o) {
  const col = o.col || '#ffffff', E = (x) => stage.fx.push(Object.assign({ x: o.x, y: o.y, f: 1, s: 1, t: 0, col }, x));
  switch (o.k) {
    case 'crescent': E({ type: 'crescent', f: o.f, life: 0.95, vx: o.vx, vy: o.vy }); break;
    case 'fire': E({ type: 'fire', life: 1.2, seed: Math.random() * 10, pal: o.pal }); break;
    case 'spike': E({ type: 'spike', life: 0.6, pal: o.pal, h: o.h }); break;
    case 'spark': E({ type: 'spark', y: o.y - 50, life: 0.3, big: 1 }); stage.shake = Math.max(stage.shake, 5); break;
    case 'thunder': {
      const pts = []; let x = 0;
      for (let y = -300; y <= 0; y += 25) { pts.push([x, y]); x += rnd(-14, 14); }
      pts[pts.length - 1] = [0, 0];
      E({ type: 'thunder', life: 0.75, pts }); stage.shake = Math.max(stage.shake, 5); break;
    }
    case 'rain': {
      const list = [];
      for (let i = 0; i < 26; i++) list.push({ x: rnd(-70, 70), y: rnd(-40, 40), t0: rnd(0, 0.55) });
      E({ type: 'rain', life: 1.4, list }); break;
    }
    case 'slam':
      E({ type: 'slam', ground: true, life: 1.2, cracks: cracks(9, 40, 90) });
      for (let i = 0; i < 18; i++) stage.parts.push({ kind: 'dust', x: o.x + rnd(-30, 30), y: o.y + rnd(-6, 6), vx: rnd(-80, 80), vy: -rnd(10, 50), g: 20, t: 0, life: rnd(0.6, 1.1), size: rnd(6, 12) });
      for (let i = 0; i < 10; i++) stage.parts.push({ kind: 'rock', x: o.x + rnd(-20, 20), y: o.y - 4, vx: rnd(-120, 120), vy: -rnd(120, 260), g: 700, t: 0, life: rnd(0.8, 1.2), size: rnd(1.5, 3), floor: o.y + rnd(-8, 8), rot: rnd(0, 6) });
      stage.shake = Math.max(stage.shake, 10); break;
    case 'heal':
      E({ type: 'heal', ground: true, life: 1.4 });
      for (let i = 0; i < 16; i++) stage.parts.push({ kind: 'cross', x: o.x + rnd(-120, 120), y: o.y + rnd(-60, 60), vx: 0, vy: -rnd(30, 70), g: 0, t: -rnd(0, 0.6), life: 1, size: 4, col });
      break;
    case 'puff':
      for (let i = 0; i < 12; i++) stage.parts.push({ kind: 'dust', x: o.x + rnd(-16, 16), y: o.y - rnd(0, 70), vx: rnd(-40, 40), vy: -rnd(0, 30), g: 0, t: 0, life: rnd(0.4, 0.7), size: rnd(5, 9), tint: '#b8c2d6' });
      break;
    case 'warn': E({ type: 'warn', ground: true, life: o.t || 1, r: o.r || 90 }); break;
    case 'bladering': E({ type: 'bladering', ground: true, life: 0.4, r: o.r || 260 }); stage.shake = Math.max(stage.shake, 4); break; // 周泰「刀舞」：一圈刀光
  }
};

SG.hitSpark = function (stage, target, col) {
  const P = target.P || { px: 0, py: 0 };
  stage.fx.push({ type: 'spark', x: target.x + target.f * (P.px + 4) * target.s, y: target.y + (P.py - 50) * target.s, f: 1, s: target.s, t: 0, life: 0.25, col: col || '#ffe08a' });
};
SG.floatText = function (stage, x, y, str, col, size) {
  stage.fx.push({ type: 'text', x, y, f: 1, s: 1, t: 0, life: 0.9, str, col, size: size || 14 });
};

SG.updateFx = function (stage, dt) {
  stage.fx = stage.fx.filter((e) => {
    e.t += dt;
    if (e.t < 0) return true;
    if (e.type === 'crescent' || e.type === 'bolt') {
      if (e.vx !== undefined) { e.x += e.vx * dt; e.y += e.vy * dt; } else e.x += e.f * (e.speed || 0) * e.s * dt;
      const k = e.type === 'crescent' ? 0.7 : e.shape === 'fire' ? 0.8 : 0.25;
      if (Math.random() < k) stage.parts.push({ kind: 'ember', x: e.x - e.f * rnd(0, 20) * e.s, y: e.y - (e.type === 'bolt' ? rnd(44, 56) : rnd(10, 85)) * e.s, vx: -e.f * rnd(20, 60) * e.s, vy: rnd(-30, 10) * e.s, g: 0, t: 0, life: rnd(0.3, 0.6), size: rnd(1.5, 3) * e.s, col: e.shape === 'fire' ? '#ffb24a' : e.col });
    }
    if (e.type === 'fire' && e.t < e.life * 0.8 && Math.random() < (e.small ? 0.2 : 0.5)) {
      stage.parts.push({ kind: 'ember', x: e.x + rnd(-14, 14) * e.s, y: e.y - rnd(10, 60) * e.s, vx: rnd(-15, 15) * e.s, vy: -rnd(40, 110) * e.s, g: 0, t: 0, life: rnd(0.4, 0.9), size: rnd(1.5, 3) * e.s, col: pal(e.pal)[4] });
    }
    return e.t < e.life;
  });
  stage.parts = stage.parts.filter((p) => {
    p.t += dt;
    if (p.t < 0) return true;
    p.vy += p.g * dt; p.x += p.vx * dt; p.y += p.vy * dt;
    if (p.floor !== undefined && p.y > p.floor) { p.y = p.floor; p.vy *= -0.35; p.vx *= 0.6; }
    return p.t < p.life;
  });
};

function rr(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y); ctx.lineTo(x + w - r, y); ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r); ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h); ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r); ctx.quadraticCurveTo(x, y, x + r, y); ctx.closePath();
}
function flame(ctx, o, w, hgt, p, T, i) {
  const lg = ctx.createLinearGradient(0, 0, 0, -hgt);
  lg.addColorStop(0, p[0]); lg.addColorStop(0.35, p[1]); lg.addColorStop(1, p[2]);
  ctx.fillStyle = lg;
  ctx.beginPath(); ctx.moveTo(o - w, 0);
  ctx.bezierCurveTo(o - w, -hgt * 0.5, o - w * 0.2, -hgt * 0.7, o + Math.sin(T * 7 + i) * 4, -hgt);
  ctx.bezierCurveTo(o + w * 0.2, -hgt * 0.7, o + w, -hgt * 0.5, o + w, 0);
  ctx.closePath(); ctx.fill();
}
function glowDot(ctx, x, y, r, col, a) {
  const g = ctx.createRadialGradient(x, y, 0, x, y, r);
  g.addColorStop(0, col); g.addColorStop(1, 'rgba(0,0,0,0)');
  ctx.globalAlpha = a; ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, r, 0, TAU); ctx.fill();
}
function arrow(ctx, x, y, ang, len) {
  ctx.save(); ctx.translate(x, y); ctx.rotate(ang);
  ctx.strokeStyle = '#d8cdb5'; ctx.lineWidth = 1.6; ctx.beginPath(); ctx.moveTo(-len, 0); ctx.lineTo(0, 0); ctx.stroke();
  ctx.fillStyle = '#e6ebf0'; ctx.strokeStyle = SG.INK; ctx.lineWidth = 1;
  ctx.beginPath(); ctx.moveTo(0, -3); ctx.lineTo(7, 0); ctx.lineTo(0, 3); ctx.closePath(); ctx.fill(); ctx.stroke();
  ctx.strokeStyle = '#f3ead6'; ctx.lineWidth = 1.2;
  ctx.beginPath(); ctx.moveTo(-len, 0); ctx.lineTo(-len - 4, -3); ctx.moveTo(-len, 0); ctx.lineTo(-len - 4, 3); ctx.stroke();
  ctx.restore();
}

const FX = {
  swoosh(ctx, e, k) {
    const t1 = (90 - e.a1) * D, t2 = (90 - e.a2) * D, ccw = t2 < t1, cy = -50, band = (r0, r1, a0, a1) => { ctx.beginPath(); ctx.arc(0, cy, r0, a0, a1, ccw); ctx.arc(0, cy, r1, a1, a0, !ccw); ctx.closePath(); };
    ctx.globalCompositeOperation = 'lighter';
    // 外層柔光：比刀光寬，淡淡一層
    band(e.r + 8, e.r - 34 * (1 - 0.4 * k), t1, t2); ctx.globalAlpha = 0.2 * (1 - k); ctx.fillStyle = e.col; ctx.fill();
    // 殘影：往揮動的反方向拖兩道越來越淡的細弧
    for (let j = 1; j <= 2; j++) {
      const back = (t2 - t1) * 0.12 * j;
      ctx.globalAlpha = (0.35 - j * 0.12) * (1 - k); ctx.strokeStyle = e.col; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.arc(0, cy, e.r - 6 - j * 5, t1, t2 - back, ccw); ctx.stroke();
    }
    // 主刀光與白色核心
    band(e.r, e.r - 18 * (1 - 0.5 * k), t1, t2); ctx.globalAlpha = 0.6 * (1 - k); ctx.fillStyle = e.col; ctx.fill();
    ctx.globalAlpha = 1 - k; ctx.strokeStyle = '#ffffff'; ctx.lineWidth = 3.4 * (1 - k) + 0.5;
    ctx.beginPath(); ctx.arc(0, cy, e.r - 2, t1 + (t2 - t1) * 0.2, t2, ccw); ctx.stroke();
    // 刀尖的亮點
    if (k < 0.5) { ctx.globalAlpha = 1 - k * 2; ctx.fillStyle = '#ffffff'; ctx.beginPath(); ctx.arc(Math.cos(t2) * (e.r - 4), cy + Math.sin(t2) * (e.r - 4), 4.5 * (1 - k), 0, TAU); ctx.fill(); }
  },
  thrust(ctx, e, k) {
    ctx.globalCompositeOperation = 'lighter'; ctx.lineCap = 'round';
    const x0 = 34 + k * 26, x1 = x0 + e.len * (0.4 + 0.6 * Math.min(1, k * 3));
    [[-5, 1.4, e.col], [0, 3.2, '#ffffff'], [5, 1.4, e.col]].forEach(([dy, w, c], i) => {
      ctx.globalAlpha = (1 - k) * (i === 1 ? 1 : 0.7); ctx.strokeStyle = c; ctx.lineWidth = w * (1.2 - k);
      ctx.beginPath(); ctx.moveTo(x0 + Math.abs(dy) * 2, -44 + dy); ctx.lineTo(x1 - Math.abs(dy) * 3, -44 + dy); ctx.stroke();
    });
  },
  ghost(ctx, e, k, T) { ctx.globalAlpha = 0.5 * (1 - k); SG.drawHero(ctx, e.spec, e.pose, T * 1000); },
  figure(ctx, e, k, T) { // 召喚出的虛影士兵
    ctx.globalAlpha = k < 0.15 ? k / 0.15 * 0.8 : k > 0.7 ? (1 - k) / 0.3 * 0.8 : 0.8;
    SG.drawHero(ctx, e.spec, e.pose, T * 1000);
  },
  crescent(ctx, e, k) {
    const fade = k < 0.08 ? k / 0.08 : k > 0.7 ? (1 - k) / 0.3 : 1;
    ctx.globalCompositeOperation = 'lighter';
    for (let g = 3; g >= 0; g--) {
      ctx.globalAlpha = fade * (g === 0 ? 0.9 : 0.22 / g);
      const cx = -g * 24, cy = -46, sc = 1 - g * 0.06;
      ctx.beginPath(); ctx.arc(cx, cy, 46 * sc, -1.25, 1.25); ctx.arc(cx - 17 * sc, cy, 42 * sc, 1.05, -1.05, true); ctx.closePath();
      ctx.fillStyle = e.col; ctx.fill();
      if (g === 0) { ctx.strokeStyle = '#ffffff'; ctx.lineWidth = 2.5; ctx.beginPath(); ctx.arc(cx, cy, 44, -1.1, 1.1); ctx.stroke(); }
    }
  },
  fire(ctx, e, k, T) {
    const p = pal(e.pal), sc = e.small ? 0.55 : 1;
    const env = k < 0.15 ? k / 0.15 : k > 0.65 ? Math.max(0, (1 - k) / 0.35) : 1;
    ctx.globalCompositeOperation = 'lighter';
    const g = ctx.createRadialGradient(0, 0, 0, 0, 0, 50 * sc);
    g.addColorStop(0, 'rgba(' + p[3] + ',' + (0.55 * env).toFixed(3) + ')'); g.addColorStop(1, 'rgba(' + p[3] + ',0)');
    ctx.save(); ctx.scale(1, 0.32); ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, 0, 50 * sc, 0, TAU); ctx.fill(); ctx.restore();
    for (let i = 0; i < 4; i++) {
      const o = ((i - 1.5) * 9 + Math.sin(T * 9 + i * 2 + e.seed) * 3) * sc;
      const hgt = Math.max(1, 100 * sc * env * (0.55 + 0.45 * Math.abs(Math.sin(i * 1.7 + e.seed))) * (0.85 + 0.15 * Math.sin(T * 15 + i)));
      flame(ctx, o, (13 - Math.abs(i - 1.5) * 3) * sc, hgt, p, T, i);
    }
  },
  aura(ctx, e, k) {
    const R = 24 + 150 * (1 - Math.pow(1 - k, 3)), a = 1 - k;
    ctx.globalAlpha = a * 0.4; ctx.fillStyle = e.col;
    ctx.beginPath(); ctx.ellipse(0, 0, R, R * 0.3, 0, 0, TAU); ctx.fill();
    ctx.globalAlpha = a; ctx.strokeStyle = '#e8c25a'; ctx.lineWidth = 3; ctx.stroke();
    ctx.strokeStyle = e.col; ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.ellipse(0, 0, R * 0.72, R * 0.72 * 0.3, 0, 0, TAU); ctx.stroke();
    ctx.fillStyle = '#e8c25a';
    for (let i = 0; i < 12; i++) { const ang = (i / 12) * TAU + k * 1.5; ctx.fillRect(Math.cos(ang) * R * 0.86 - 1.5, Math.sin(ang) * R * 0.86 * 0.3 - 1.5, 3, 3); }
  },
  seal(ctx, e, k) {
    const pop = k < 0.12 ? 1.7 - 0.7 * (k / 0.12) : 1;
    ctx.globalAlpha = k > 0.7 ? (1 - k) / 0.3 : Math.min(1, k / 0.06);
    ctx.translate(0, -k * 18); ctx.scale(pop, pop);
    rr(ctx, -17, -26, 34, 52, 6); ctx.fillStyle = '#1e2a52'; ctx.fill(); ctx.lineWidth = 3; ctx.strokeStyle = '#e8c25a'; ctx.stroke();
    ctx.lineWidth = 1; rr(ctx, -13, -22, 26, 44, 4); ctx.stroke();
    ctx.fillStyle = '#f0cf6a'; ctx.font = '900 28px "Noto Serif TC", "Songti TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText(e.ch, 0, 1);
  },
  roar(ctx, e, k) {
    ctx.lineCap = 'round';
    for (let i = 0; i < 3; i++) {
      const kk = k - i * 0.14;
      if (kk <= 0) continue;
      const R = 12 + 150 * kk;
      ctx.globalAlpha = Math.max(0, 1 - kk); ctx.strokeStyle = i === 0 ? '#ffffff' : e.col; ctx.lineWidth = 5 * (1 - kk) + 1;
      ctx.beginPath(); ctx.ellipse(16, -70, R, R * 0.8, 0, -0.9, 0.9); ctx.stroke();
    }
  },
  slam(ctx, e, k) {
    const a = k > 0.6 ? (1 - k) / 0.4 : 1;
    const draw = () => { for (const c of e.cracks) { ctx.beginPath(); ctx.moveTo(c[0][0], c[0][1]); for (const p of c) ctx.lineTo(p[0], p[1]); ctx.stroke(); } };
    ctx.globalAlpha = a; ctx.strokeStyle = SG.INK; ctx.lineWidth = 2.6; ctx.lineJoin = 'round'; draw();
    if (k < 0.45) { ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = (0.45 - k) / 0.45; ctx.strokeStyle = '#ffb050'; ctx.lineWidth = 1.2; draw(); }
    const R = 20 + 140 * k;
    ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = (1 - k) * 0.8; ctx.strokeStyle = e.col; ctx.lineWidth = 3 * (1 - k);
    ctx.beginPath(); ctx.ellipse(0, 0, R, R * 0.3, 0, 0, TAU); ctx.stroke();
  },
  spark(ctx, e, k) {
    ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = 1 - k; ctx.lineCap = 'round';
    const R0 = 4 + 10 * k, R1 = (e.big ? 16 : 12) + 16 * k;
    for (let i = 0; i < 8; i++) {
      const ang = (i / 8) * TAU + 0.3;
      ctx.strokeStyle = i % 2 ? e.col : '#ffffff'; ctx.lineWidth = (i % 2 ? 2 : 3) * (1 - k) + 0.5;
      ctx.beginPath(); ctx.moveTo(Math.cos(ang) * R0, Math.sin(ang) * R0); ctx.lineTo(Math.cos(ang) * R1, Math.sin(ang) * R1); ctx.stroke();
    }
    ctx.fillStyle = '#ffffff'; ctx.beginPath(); ctx.arc(0, 0, 5 * (1 - k) + 0.1, 0, TAU); ctx.fill();
  },
  bolt(ctx, e, k, T) {
    const a = k > 0.8 ? (1 - k) / 0.2 : 1, y = e.h !== undefined ? e.h : -50, sc = e.big ? 1.6 : 1;
    if (e.up) { // 朝天射出的箭
      ctx.globalAlpha = a; arrow(ctx, 20 + k * 60, y - k * 260, -1.2, 22); return;
    }
    if (!e.noStreak && e.shape !== 'waterball') { // 普攻的追蹤投射物不畫通用光痕（v0.3.4），外觀才分得出來；水球是球體，不拖光痕
      ctx.globalCompositeOperation = 'lighter';
      ctx.globalAlpha = a * 0.5; ctx.strokeStyle = e.col; ctx.lineWidth = 3 * sc; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(-60 * sc, y); ctx.lineTo(-10, y); ctx.stroke();
    }
    ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = a;
    switch (e.shape) {
      case 'arrow': arrow(ctx, 0, y, 0, 26); break;
      case 'wind':
        ctx.strokeStyle = e.col; ctx.lineWidth = 2.5;
        for (let i = 0; i < 3; i++) { ctx.globalAlpha = a * (1 - i * 0.25); ctx.beginPath(); ctx.arc(-i * 10, y, 14 * sc - i * 2, -1.1, 1.1); ctx.stroke(); }
        break;
      case 'blade': {
        ctx.save(); ctx.translate(0, y); ctx.rotate(T * 22); ctx.scale(sc, sc);
        SG.draw.poly(ctx, [[0, -12], [3, -3], [12, 0], [3, 3], [0, 12], [-3, 3], [-12, 0], [-3, -3]], '#d6dce2', 1.6);
        ctx.restore(); break;
      }
      case 'xbolt': { // 弩矢：短、粗、方尾羽、鐵鏃大
        ctx.save(); ctx.translate(0, y); ctx.scale(sc, sc);
        ctx.strokeStyle = SG.INK; ctx.lineWidth = 4.4; ctx.beginPath(); ctx.moveTo(-16, 0); ctx.lineTo(2, 0); ctx.stroke();
        ctx.strokeStyle = '#8a5a2e'; ctx.lineWidth = 2.6; ctx.stroke();
        SG.draw.poly(ctx, [[2, -4], [11, 0], [2, 4]], '#cfd6dc', 1.2);
        SG.draw.poly(ctx, [[-16, -1], [-20, -5], [-12, -1]], '#c4453a', 1); SG.draw.poly(ctx, [[-16, 1], [-20, 5], [-12, 1]], '#c4453a', 1);
        ctx.restore(); break;
      }
      case 'ink': { // 墨跡：一筆濃墨，筆鋒拖尾，帶幾點飛白
        ctx.save(); ctx.translate(0, y); ctx.scale(sc, sc);
        ctx.fillStyle = '#14100e'; ctx.beginPath(); ctx.moveTo(10, 0); ctx.quadraticCurveTo(4, -7, -6, -4); ctx.quadraticCurveTo(-22, -1, -30, 1); ctx.quadraticCurveTo(-18, 3, -6, 5); ctx.quadraticCurveTo(4, 7, 10, 0); ctx.fill();
        ctx.globalAlpha = a * 0.7; ctx.fillStyle = e.col; ctx.beginPath(); ctx.ellipse(2, -1, 5, 2, 0, 0, TAU); ctx.fill();
        ctx.globalAlpha = a; ctx.fillStyle = '#14100e'; [[-12, -7, 1.6], [-20, 6, 1.2], [-4, 8, 1]].forEach(([x, yy, r]) => { ctx.beginPath(); ctx.arc(x, yy, r, 0, TAU); ctx.fill(); });
        ctx.restore(); break;
      }
      case 'card': { // 擲牌：旋轉的竹牌（楊修謎題）
        ctx.save(); ctx.translate(0, y); ctx.rotate(T * 14); ctx.scale(sc, sc);
        SG.draw.poly(ctx, [[-6, -8], [6, -8], [6, 8], [-6, 8]], '#e8d8b0', 1.4);
        ctx.fillStyle = '#c4302a'; ctx.font = '900 8px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('謎', 0, 0.5);
        ctx.restore(); break;
      }
      case 'qi': { // 劍氣：細長新月光刃，白芯＋武將色光暈
        ctx.save(); ctx.translate(0, y); ctx.scale(sc, sc); ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = e.col; ctx.globalAlpha = a * 0.55; ctx.beginPath(); ctx.moveTo(10, 0); ctx.quadraticCurveTo(-2, -16, -14, -18); ctx.quadraticCurveTo(-4, -8, -6, 0); ctx.quadraticCurveTo(-4, 8, -14, 18); ctx.quadraticCurveTo(-2, 16, 10, 0); ctx.fill();
        ctx.fillStyle = '#ffffff'; ctx.globalAlpha = a * 0.95; ctx.beginPath(); ctx.moveTo(8, 0); ctx.quadraticCurveTo(-1, -11, -9, -13); ctx.quadraticCurveTo(-2, -6, -3, 0); ctx.quadraticCurveTo(-2, 6, -9, 13); ctx.quadraticCurveTo(-1, 11, 8, 0); ctx.fill();
        ctx.restore(); break;
      }
      case 'knife': { // 飛刀：旋轉，刀身＋刀環
        ctx.save(); ctx.translate(0, y); ctx.rotate(T * 24); ctx.scale(sc, sc);
        SG.draw.poly(ctx, [[0, -13], [3, -2], [0, 2], [-3, -2]], '#e6ebf0', 1.3);
        ctx.strokeStyle = SG.INK; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(0, 2); ctx.lineTo(0, 8); ctx.stroke(); ctx.strokeStyle = '#8a3a2a'; ctx.lineWidth = 1.6; ctx.stroke();
        ctx.lineWidth = 1.4; ctx.strokeStyle = '#e9c46a'; ctx.beginPath(); ctx.arc(0, 10.5, 2.6, 0, TAU); ctx.stroke();
        ctx.restore(); break;
      }
      case 'dart': { // 飛鏢：鏢頭＋紅纓，淬毒的綠光
        ctx.save(); ctx.translate(0, y); ctx.scale(sc, sc);
        glowDot(ctx, 2, 0, 9, 'rgba(150,240,90,.9)', a * 0.8); ctx.globalAlpha = a;
        SG.draw.poly(ctx, [[10, 0], [0, -3], [-6, 0], [0, 3]], '#d6dce2', 1.2);
        ctx.strokeStyle = '#c4302a'; ctx.lineWidth = 1.6; [[-12, -4], [-13, 0], [-12, 4]].forEach(([x, yy]) => { ctx.beginPath(); ctx.moveTo(-6, 0); ctx.lineTo(x, yy); ctx.stroke(); });
        ctx.restore(); break;
      }
      case 'fire': glowDot(ctx, 0, y, 18 * sc, '#ffcf6a', a); glowDot(ctx, 0, y, 8 * sc, '#ffffff', a); break;
      case 'ice':
        ctx.save(); ctx.translate(0, y); ctx.scale(sc, sc);
        SG.draw.poly(ctx, [[14, 0], [0, -6], [-10, 0], [0, 6]], '#d8f2ff', 1.4); ctx.restore(); break;
      case 'waterball': { // 水球（孫權 碧浪奔襲）：半透明的大水球，表面一圈亮邊＋高光
        ctx.save(); ctx.translate(0, y);
        const R = 30, g = ctx.createRadialGradient(-R * 0.35, -R * 0.35, R * 0.1, 0, 0, R);
        g.addColorStop(0, 'rgba(230,250,255,.95)'); g.addColorStop(0.45, 'rgba(95,196,232,.75)'); g.addColorStop(1, 'rgba(30,110,170,.55)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, 0, R, 0, TAU); ctx.fill();
        ctx.strokeStyle = 'rgba(210,245,255,.9)'; ctx.lineWidth = 2; ctx.stroke();
        ctx.globalAlpha = a * 0.8; ctx.strokeStyle = '#ffffff'; ctx.lineWidth = 2.5; ctx.beginPath(); ctx.arc(0, 0, R * 0.7, Math.PI * 1.1 + Math.sin(T * 6) * 0.1, Math.PI * 1.45 + Math.sin(T * 6) * 0.1); ctx.stroke();
        ctx.restore(); break;
      }
      default: glowDot(ctx, 0, y, 16 * sc, e.col, a); glowDot(ctx, 0, y, 6 * sc, '#ffffff', a);
    }
  },
  rain(ctx, e, k) {
    const t = k * e.life;
    ctx.globalAlpha = Math.min(1, (1 - k) * 3) * 0.5; ctx.strokeStyle = e.col; ctx.setLineDash([5, 5]); ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.ellipse(0, 0, 76, 18, 0, 0, TAU); ctx.stroke(); ctx.setLineDash([]);
    for (const r of e.list) {
      const p = (t - r.t0) / 0.28;
      if (p < 0) continue;
      ctx.globalAlpha = k > 0.8 ? (1 - k) / 0.2 : 1;
      if (p < 1) arrow(ctx, r.x - 60 * (1 - p), r.y - 200 * (1 - p), Math.atan2(200, 60), 20);
      else arrow(ctx, r.x - 4, r.y - 10, Math.atan2(200, 60), 8);
    }
  },
  whirl(ctx, e, k) {
    ctx.globalAlpha = (1 - k) * 0.8; ctx.strokeStyle = e.col; ctx.lineWidth = 2.5; ctx.setLineDash([14, 10]);
    ctx.lineDashOffset = -k * 120;
    ctx.beginPath(); ctx.ellipse(0, 0, 60 + 20 * k, 16 + 5 * k, 0, 0, TAU); ctx.stroke(); ctx.setLineDash([]);
  },
  buff(ctx, e, k) {
    const a = (k < 0.2 ? k / 0.2 : (1 - k) / 0.8) * (e.small ? 0.5 : 0.8);
    ctx.globalCompositeOperation = 'lighter';
    const g = ctx.createLinearGradient(0, 0, 0, -120);
    g.addColorStop(0, e.col); g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.globalAlpha = a * 0.5; ctx.fillStyle = g; ctx.fillRect(-26, -120, 52, 120);
    ctx.globalAlpha = a; ctx.strokeStyle = e.col; ctx.lineWidth = 2.5;
    ctx.beginPath(); ctx.ellipse(0, 0, 30, 8, 0, 0, TAU); ctx.stroke();
  },
  heal(ctx, e, k) {
    const R = 40 + 60 * Math.min(1, k * 3), a = 1 - k;
    ctx.globalAlpha = a * 0.3; ctx.fillStyle = e.col; ctx.beginPath(); ctx.ellipse(0, 0, R, R * 0.3, 0, 0, TAU); ctx.fill();
    ctx.globalAlpha = a; ctx.strokeStyle = e.col; ctx.lineWidth = 2.5; ctx.stroke();
  },
  chain(ctx, e, k) {
    const ext = k < 0.4 ? k / 0.4 : k < 0.6 ? 1 : 1 - (k - 0.6) / 0.4;
    const L = e.d * ext, y = -48, x0 = 24;
    ctx.strokeStyle = SG.INK; ctx.fillStyle = '#9aa1a8'; ctx.lineWidth = 1.2;
    for (let x = x0; x < x0 + L; x += 7) { ctx.beginPath(); ctx.ellipse(x, y, 3.5, 2.2, 0, 0, TAU); ctx.fill(); ctx.stroke(); }
    ctx.save(); ctx.translate(x0 + L, y);
    ctx.beginPath(); ctx.moveTo(0, 0); ctx.quadraticCurveTo(12, -2, 10, 10); ctx.quadraticCurveTo(6, 6, 4, 8);
    ctx.lineWidth = 3; ctx.strokeStyle = '#d6dce2'; ctx.stroke(); ctx.restore();
    ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = 0.5; ctx.strokeStyle = e.col; ctx.lineWidth = 4;
    ctx.beginPath(); ctx.moveTo(x0, y); ctx.lineTo(x0 + L, y); ctx.stroke();
  },
  thunder(ctx, e, k) {
    if (k < 0.45) {
      const flick = Math.random() < 0.8 ? 1 : 0.4;
      ctx.globalCompositeOperation = 'lighter';
      const path = () => { ctx.beginPath(); e.pts.forEach((p, i) => (i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]))); };
      ctx.globalAlpha = 0.45 * flick; ctx.strokeStyle = e.col; ctx.lineWidth = 10; ctx.lineJoin = 'round'; path(); ctx.stroke();
      ctx.globalAlpha = flick; ctx.strokeStyle = '#ffffff'; ctx.lineWidth = 3; path(); ctx.stroke();
      glowDot(ctx, 0, 0, 60, e.col, (0.45 - k) / 0.45);
    }
    ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = (1 - k) * 0.7; ctx.strokeStyle = SG.INK; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.ellipse(0, 0, 34, 9, 0, 0, TAU); ctx.stroke();
  },
  shield(ctx, e, k) {
    const a = k < 0.12 ? k / 0.12 : k > 0.8 ? (1 - k) / 0.2 : 1;
    ctx.globalAlpha = a * 0.16; ctx.fillStyle = e.col; ctx.beginPath(); ctx.ellipse(0, -50, 38, 56, 0, 0, TAU); ctx.fill();
    ctx.globalAlpha = a * 0.9; ctx.strokeStyle = e.col; ctx.lineWidth = 2.4; ctx.stroke();
    ctx.save(); ctx.clip(); ctx.globalAlpha = a * 0.35; ctx.lineWidth = 1;
    for (let y = -110; y < 10; y += 14) for (let x = -40; x < 40; x += 16) { const ox = ((y / 14) & 1) * 8; ctx.beginPath(); ctx.moveTo(x + ox, y); ctx.lineTo(x + ox + 8, y + 5); ctx.lineTo(x + ox + 16, y); ctx.stroke(); }
    ctx.restore();
  },
  trap(ctx, e, k) {
    const a = k < 0.1 ? k / 0.1 : k > 0.8 ? (1 - k) / 0.2 : 1;
    ctx.globalAlpha = a;
    for (const b of e.bits) {
      if (e.shape === 'stones') SG.draw.poly(ctx, [[b[0] - 6, b[1]], [b[0] - 4, b[1] - 12], [b[0] + 4, b[1] - 14], [b[0] + 6, b[1]]], '#8a8478', 1.4);
      else SG.draw.poly(ctx, [[b[0] - 4, b[1] + 2], [b[0], b[1] - 5], [b[0] + 4, b[1] + 2]], '#9aa1a8', 1.2);
    }
    ctx.strokeStyle = e.col; ctx.globalAlpha = a * 0.6; ctx.setLineDash([4, 5]); ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.ellipse(0, 0, 62, 17, 0, 0, TAU); ctx.stroke(); ctx.setLineDash([]);
  },
  bladering(ctx, e, k) { // 刀光繞身一圈：四道弧刃由內往外掃到技能半徑
    const K = SG.K || 0.7, R = e.r * (0.35 + 0.65 * Math.min(1, k * 1.6)), rot = k * TAU * 1.25;
    ctx.globalCompositeOperation = 'lighter'; ctx.lineCap = 'round';
    for (let i = 0; i < 4; i++) {
      const a0 = rot + i * TAU / 4;
      ctx.globalAlpha = (1 - k) * 0.9; ctx.strokeStyle = e.col; ctx.lineWidth = 7 * (1 - k) + 1;
      ctx.beginPath(); ctx.ellipse(0, 0, R, R * K, 0, a0, a0 + 1.1); ctx.stroke();
      ctx.globalAlpha = (1 - k) * 0.7; ctx.strokeStyle = '#ffffff'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.ellipse(0, 0, R, R * K, 0, a0 + 0.5, a0 + 1.1); ctx.stroke();
    }
    ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = (1 - k) * 0.25; ctx.fillStyle = e.col;
    ctx.beginPath(); ctx.ellipse(0, 0, R, R * K, 0, 0, TAU); ctx.fill();
  },
  warn(ctx, e, k) { // 延遲技能的預警圈：越接近落下越紅
    const K = SG.K || 0.7;
    ctx.globalAlpha = 0.25 + 0.5 * k; ctx.fillStyle = 'rgba(255,80,60,' + (0.1 + 0.25 * k).toFixed(2) + ')';
    ctx.beginPath(); ctx.ellipse(0, 0, e.r * k, e.r * K * k, 0, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = '#ff5a4a'; ctx.lineWidth = 2.5; ctx.setLineDash([8, 6]);
    ctx.beginPath(); ctx.ellipse(0, 0, e.r, e.r * K, 0, 0, Math.PI * 2); ctx.stroke(); ctx.setLineDash([]);
  },
  spike(ctx, e, k, T) { // 單根地刺（方向型地裂由多根組成）
    const h = Math.sin(Math.min(1, k) * Math.PI) * (e.h || 40);
    if (h <= 0.5) return;
    if (e.pal) { ctx.globalCompositeOperation = 'lighter'; flame(ctx, 0, 9, h * 1.4, pal(e.pal), T, 1); return; }
    SG.draw.poly(ctx, [[-9, 0], [-2, -h], [3, -h * 0.7], [9, 0]], '#8a7d66', 1.8);
    ctx.strokeStyle = e.col; ctx.globalAlpha = 0.7; ctx.lineWidth = 1.2; SG.draw.line(ctx, [-2, -h], [0, -h * 0.3]);
  },
  spikes(ctx, e, k, T) {
    const t = k * e.life;
    for (let i = 0; i < e.n; i++) {
      const lt = (t - i * 0.07) / 0.6;
      if (lt <= 0 || lt >= 1) continue;
      const h = Math.sin(lt * Math.PI) * (36 + i * 4), x = 48 + i * 34;
      ctx.save(); ctx.translate(x, 0);
      if (e.pal) { ctx.globalCompositeOperation = 'lighter'; flame(ctx, 0, 9, h * 1.4, pal(e.pal), T, i); }
      else { ctx.globalAlpha = 1; SG.draw.poly(ctx, [[-9, 0], [-2, -h], [3, -h * 0.7], [9, 0]], '#8a7d66', 1.8); ctx.strokeStyle = e.col; ctx.globalAlpha = 0.7; ctx.lineWidth = 1.2; SG.draw.line(ctx, [-2, -h], [0, -h * 0.3]); }
      ctx.restore();
    }
  },
};

SG.FX = FX;
function drawText(ctx, e, k) {
  const pop = k < 0.1 ? 1.5 - 0.5 * (k / 0.1) : 1;
  const jx = e.shake && k < 0.4 ? (Math.random() - 0.5) * 4 : 0;
  ctx.translate(e.x + jx, e.y - 16 * k * e.s); ctx.scale(pop * e.s, pop * e.s);
  ctx.globalAlpha = k > 0.75 ? (1 - k) / 0.25 : 1;
  ctx.font = '900 ' + e.size + 'px "Noto Serif TC", "Songti TC", serif';
  ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.lineJoin = 'round';
  ctx.lineWidth = 6; ctx.strokeStyle = SG.INK; ctx.strokeText(e.str, 0, 0);
  ctx.fillStyle = e.col; ctx.fillText(e.str, 0, 0);
}

SG.drawFx = function (ctx, stage, ground) {
  const T = stage.time;
  for (const e of stage.fx) {
    if (e.t < 0 || !!e.ground !== ground) continue;
    const k = clamp01(e.t / e.life);
    ctx.save();
    if (e.type === 'text') drawText(ctx, e, k);
    else { ctx.translate(e.x, e.y); ctx.scale((e.f || 1) * e.s, e.s); FX[e.type](ctx, e, k, T); }
    ctx.restore();
  }
};

SG.drawParts = function (ctx, stage) {
  for (const p of stage.parts) {
    if (p.t < 0) continue;
    const k = p.t / p.life, a = 1 - k;
    ctx.save();
    switch (p.kind) {
      case 'ember':
        ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = a; ctx.fillStyle = p.col;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.size * (1 - k * 0.5), 0, TAU); ctx.fill(); break;
      case 'dust':
        ctx.globalAlpha = 0.45 * a; ctx.fillStyle = p.tint || '#a8977a';
        ctx.beginPath(); ctx.arc(p.x, p.y, p.size * (1 + k * 1.6), 0, TAU); ctx.fill(); break;
      case 'rock':
        ctx.globalAlpha = Math.min(1, a * 2); ctx.translate(p.x, p.y); ctx.rotate(p.rot + p.t * 8);
        ctx.fillStyle = '#6b5d4c'; ctx.strokeStyle = SG.INK; ctx.lineWidth = 1;
        ctx.fillRect(-p.size, -p.size, p.size * 2, p.size * 2); ctx.strokeRect(-p.size, -p.size, p.size * 2, p.size * 2); break;
      case 'chev':
        ctx.globalAlpha = a; ctx.strokeStyle = p.col; ctx.lineWidth = 2; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        ctx.beginPath(); ctx.moveTo(p.x - p.size, p.y + p.size * 0.6); ctx.lineTo(p.x, p.y - p.size * 0.4); ctx.lineTo(p.x + p.size, p.y + p.size * 0.6); ctx.stroke(); break;
      case 'cross':
        ctx.globalAlpha = a; ctx.fillStyle = p.col;
        ctx.fillRect(p.x - p.size, p.y - p.size * 0.3, p.size * 2, p.size * 0.6); ctx.fillRect(p.x - p.size * 0.3, p.y - p.size, p.size * 0.6, p.size * 2); break;
    }
    ctx.restore();
  }
};
